import { IStackTokens, IStyle, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { useScreen } from 'common/hooks/useScreen';
import { IAppTheme, useAppTheme } from 'common/theme/AppTheme';

const getStyles = memoizeFunction((theme: IAppTheme, isMobileScreen: boolean) =>
  mergeStyleSets({
    pageWrapper: {
      padding: isMobileScreen ? 0 : '0 32px 40px 32px',
    } as IStyle,
    card: {
      padding: '12px 32px 36px 32px',
      '@media only screen and (max-width: 640px)': {
        position: 'fixed',
        top: 0,
        bottom: 0,
        height: 'auto',
        maxHeight: '100%',
        width: '100vw',
        minWidth: '100vw',
        maxWidth: '100vw',
      },
    } as IStyle,
    cardContentWrapper: {
      textAlign: 'center',
    } as IStyle,
    productNameWrapper: {
      display: 'flex',
    } as IStyle,
    text: {
      textAlign: 'center',
    } as IStyle,
    logoHeading: {
      padding: '12px 0px',
    } as IStyle,
    buttonSection: {
      textAlign: 'center',
    } as IStyle,
    button: {
      minWidth: 200,
      minHeight: 42,
      borderRadius: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    } as IStyle,
    primaryButton: {
      ...(isMobileScreen ? { alignSelf: 'center', minWidth: '70%' } : { minWidth: 200 }),
    } as IStyle,
    actionBtn: {
      width: isMobileScreen ? 240 : 300,
      height: 40,
    } as IStyle,
    brandedText: {
      color: theme.appColors?.bluePrimary,
      display: isMobileScreen ? 'inline-block' : 'inline',
    } as IStyle,
  })
);

export const useAppLauncherStyles = () => {
  const { isMobileScreen } = useScreen();
  const theme = useAppTheme();

  return getStyles(theme, isMobileScreen);
};

export const stackTokens = {
  pageWrapper: {
    childrenGap: 48,
  } as IStackTokens,
  cardContentWrapper: {
    childrenGap: 24,
  } as IStackTokens,
  logoHeading: {
    childrenGap: 12,
  } as IStackTokens,
  textContainer: {
    childrenGap: 12,
  } as IStackTokens,
  buttonSection: {
    childrenGap: 12,
  } as IStackTokens,
  footer: {
    childrenGap: 24,
  } as IStackTokens,
};
